import { z } from "zod";
import { messageNodeTextSchema } from "./text-field.schema";
import { messageNodeQuickReplySchema } from "./quick-reply-field.schema";
import { messageNodeMediaSchema } from "./media-field.schema";
import { messageNodeButtonSchema } from "../button-field.schema";

export const messageNodeFieldSchema = z.union([
  // messageNodeCarouselSchema,
  messageNodeTextSchema,
  messageNodeQuickReplySchema,
  messageNodeMediaSchema,
  messageNodeButtonSchema,
]);

export type MessageNodeFieldSchema = z.infer<typeof messageNodeFieldSchema>;
